
import { t } from '@/plugins/i18n'
export const labelMap: any = {
  AMAZON_ONLY: t('由亚马逊处理'),
  NONE_ONLY: t('无需更改'),
  SELLER_ONLY: t('由卖家处理'),
  UNKNOWN: t('未设置')
}
